import React from "react";
import { useLocation } from "react-router-dom";
import style from "./style.less";

const InviteProgress = ({
  percentage,
  text,
  width,
  height,
  borderRadius,
  textColor,
  fontSize,
  backgroundColor,
  progressColor,
}) => {
  let location = useLocation();
  console.log(location.pathname);
  return (
    <div class={style.jindutiao_bg} style={{ width, height, borderRadius, overflow: "hidden", marginTop: "0.1rem" }}>
      <div
        style={{
          width: "100%",
          height: "100%",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/*<span*/}
        {/*  style={{*/}
        {/*    fontSize,*/}
        {/*    color: textColor,*/}
        {/*  }}*/}
        {/*>*/}
        {/*  {text}*/}
        {/*</span>*/}
      </div>
      <div class={style.jindutiao} style={{marginTop: `-${height}`, height, width: `${percentage}%` }} />
    </div>
  );
};

export default InviteProgress;
